<template>
  <div class="timeline">
    <b-row>
      <b-col cols="12">
        <ul class="timeline">
          <li
            :class="index % 2 == 0 ? 'timeline-inverted' : ''"
            v-for="(log, index) in logs"
            :key="log.id"
          >
            <div class="timeline-badge">
              <b-tooltip :target="'#image-' + log.id">
                <span class="block">{{ log.user }}</span>
                <span class="block">{{ log.email }}</span>
              </b-tooltip>
              <b-img
                v-if="log.picture == null"
                img
                src="../img/avatar-client.png"
                alt="user-img"
                :id="'image-' + log.id"
                class="avatar img-circle"
              />
              <b-img-lazy
                v-else
                img
                :id="'image-' + log.id"
                class="avatar img-circle"
                :src="log.picture"
                alt="user-img"
              />
            </div>
            <div class="timeline-panel">
              <div class="timeline-heading">
                <h4 class="timeline-title">{{ log.context }}</h4>
                <p>
                  <small class="text-muted"
                    ><i class="glyphicon glyphicon-time"></i> le
                    {{ log.loggedAt }}</small
                  >
                </p>
              </div>
              <div class="timeline-body">
                <div v-if="typeof log.data == 'object'">
                  <div
                    v-for="(value, key) in log.data"
                    :key="log.id + '-' + key"
                  >
                    <p
                      class="no-margin no-padding"
                      v-if="
                        !exclude_key.includes(key) &&
                        value != NULL &&
                        value != ''
                      "
                    >
                      Saisie : {{ getChamps(key) }} à
                      <span v-if="typeof value == Object">
                        {{ value.id }}
                      </span>

                      <span v-else-if="value == true || value == 'true'">
                        oui
                      </span>
                      <span v-else-if="value == false || value == 'false'">
                        non
                      </span>
                      <span v-else>
                        {{ value }}
                      </span>
                    </p>
                  </div>
                </div>
                <div v-else-if="log.data != null">
                  {{ log.data }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

export default {
  name: "History",
  components: {},
  computed: {
    ...Vuex.mapGetters("Log", ["logs"]),
  },
  data: () => ({
    exclude_key: ["path", "missing_documents"],
  }),

  mounted() {
    this.queryLogs(this.entity, this.id);
  },
  props: {
    id: { type: Number, required: false, default: null },
    entity: { type: String, required: false, default: null },
  },
  methods: {
    getChamps(champs) {
      let value = "";
      switch (champs) {
        case "address_city":
          value = "ville de l'adresse";
          break;
        case "address_country":
          value = "pays de l'adresse";
          break;
        case "address_ext":
          value = "extension de l'adresse";
          break;
        case "address_name":
          value = "nom de l'adresse";
          break;
        case "address_num":
          value = "numéro de l'adresse";
          break;
        case "address_postal_code":
          value = "code postal de l'adresse";
          break;
        case "address_type":
          value = "type de l'adresse";
          break;
        case "corporation_agent":
          value = "représentant de l'entreprise";
          break;
        case "corporation_agent_title":
          value = "titre du représentant de l'entreprise";
          break;
        case "corporation_name":
          value = "nom de l'entreprise";
          break;
        case "corporation_siret":
          value = "siret de l'entreprise";
          break;
        case "email":
          value = "courriel";
          break;
        case "first_name":
          value = "nom";
          break;
        case "last_name":
          value = "prenom";
          break;
        case "nature":
          value = "nature";
          break;
        case "phone":
          value = "téléphone";
          break;
        case "phone_indicative":
          value = "indicatif téléphonique";
          break;
        case "title":
          value = "titre";
          break;
        case "quality":
          value = "Qualité";
          break;
        case "name":
          value = "nom";
          break;
        case "mime_type":
          value = "type";
          break;
        case "request":
          value = "demande";
          break;
        case "stdUser":
          value = "utilisateur";
          break;
        case "typeDocument":
          value = "type de document";
          break;
        case "url":
          value = "url";
          break;
        case "state":
          value = "état";
          break;
        case "deposit_date":
          value = "date de dépôt";
          break;
        case "lon":
          value = "longitude";
          break;
        case "lat":
          value = "latitude";
          break;
        case "way_type":
          value = "type de route";
          break;
        case "way_num":
          value = "numéro de la route";
          break;
        case "extra_urban":
          value = "hors agglomeration";
          break;
        case "operation_code":
          value = "code d'opération";
          break;
        case "date_start":
          value = "date de début";
          break;
        case "date_end":
          value = "date de fin";
          break;
        case "number_days":
          value = "nombre de jours";
          break;
        case "accuracy_information":
          value = "signature";
          break;
        case "made_in":
          value = "lieu de signature";
          break;
        case "made_first_name":
          value = "nom de la personne qui signe";
          break;
        case "made_fonction":
          value = "fonction de la personne qui signe";
          break;
        case "made_last_name":
          value = "prénom de la personne qui signe";
          break;
        case "made_date":
          value = "date de signature";
          break;
        case "made_date":
          value = "numéro d'affaire";
          break;
        case "created_at":
          value = "crée le";
          break;
        case "petitioner":
          value = "demandeur";
          break;
        case "beneficiary":
          value = "bénéficiaire";
          break;
        case "cerfa1402301":
          value = "cerfa 14023*01";
          break;
        case "alignement":
          value = "Demande d'alignement individuel";
          break;

        default:
          value = champs;
          break;
      }
      return value;
    },
    ...Vuex.mapActions("Log", ["getLogs"]),
    async queryLogs(entity, id) {
      this.getLogs({ entity: entity, id: id });
    },
  },
};
</script>

<style></style>
